<div class="row row-gap-5">
	<div class="col-12">
		<tsp-contact-info [emailAddress]="contactInfo()" (emailAddressChange)="updateEmail($event)"
			[secondEmailAddress]="secondContactInfo()" (secondEmailAddressChange)="updateSecondEmail($event)"
			(isValid)="isContactInfoValid.set($event)" />
	</div>
</div>

<div class="mt-5">
	<tsp-pin-site-care [isEnabled]="isPinSiteCareEnabled()" (isEnabledChange)="enablePinSiteCare($event)"
		[firstDay]="firstDay()" (firstDayChange)="updateFirstDay($event)" [frequency]="frequency()"
		(frequencyChange)="updateFrequency($event)" (isValid)="isPinSiteCareValid.set($event)" />
</div>

<!-- <ng-container [ngTemplateOutlet]="patAccordion" [ngTemplateOutletContext]="{
	title: labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PINSITECARE,
	isOpened: pdfPinSiteCareOpened,
	content: pinsitecarePdf
}">
</ng-container>
<ng-template #pinsitecarePdf>
	<tsp-pdf-uploader [title]="labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PINSITECARE" [fileName]="pinSiteCarePdf()"
		(dataChanged)="updatePinSiteCareFile($event)" />
</ng-template> -->

<ng-container [ngTemplateOutlet]="patAccordion" [ngTemplateOutletContext]="{
	title: labels().PATIENT_SETTINGS_COMPONENT_TITLE_MESSAGES,
	isOpened: msgOpened,
	content: motMessages
}">
</ng-container>
<ng-template #motMessages>
	<tsp-motivational-messages [data]="motMessagesData()" (isEnabledChange)="enableMotMessages($event)"
		(selectedSetChange)="updateCustomSet($event)" (enableSetChange)="updateEnableSet($event)"
		(isValid)="isMotMessagesValid.set($event)" />
</ng-template>

<!-- <ng-container [ngTemplateOutlet]="patAccordion" [ngTemplateOutletContext]="{
	title: labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PHYSIOTHERAPY,
	isOpened: pdfPhysioOpened,
	content: physioPdf
}">
</ng-container>
<ng-template #physioPdf>
	<tsp-pdf-uploader [title]="labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PHYSIOTHERAPY"
		[fileName]="physiotherapyPdf()" (dataChanged)="updatePhysiotherapyFile($event)" />
</ng-template> -->



<ng-template #patAccordion let-title="title" let-isOpened="isOpened" let-content="content">
	<div class="panel panel-thead mt-4 mb-1" (click)="accordion.toggle()" (keypress)="accordion.toggle()">
		<div class="row no-gutters">
			<div class="col short-col">
				<span class="material-icons panel-toggle align-middle">
					{{ isOpened ? 'expand_less' : 'expand_more' }}
				</span>
			</div>
			<div class="col text-start">
				<h3 class="mb-0">{{ title }}</h3>
			</div>
		</div>
	</div>
	<div #accordion="ngbCollapse" [ngbCollapse]="!isOpened">
		<div class="panel mb-1">
			<ng-container *ngTemplateOutlet="content" />
		</div>
	</div>
</ng-template>